var React = require('react');

function WebsiteInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("circle",{"cx":"12","cy":"12","r":"11","key":0}),React.createElement("path",{"d":"M2 15h20M2 9h20M11 2C9.191 4.157 8 7.83 8 12s1.191 7.843 3 10m2-20c1.809 2.157 3 5.83 3 10s-1.191 7.843-3 10","key":1})]));
}

WebsiteInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = WebsiteInline;

WebsiteInline.default = WebsiteInline;
